import type { Route, RouteConfig } from "vue-router";

import isUserLoggedIn from "@Middleware/isUserLoggedIn";
import team from "@Middleware/team";

const AppSettingsPage = () => import(/* webpackChunkName: 'dashboard'*/ "@Components/layouts/app/settings/index.vue");
const AppSettingsMenu = () => import(/* webpackChunkName: 'settings' */ "@Components/layouts/app/settings/SettingsMenu.vue");

const AppSettingsAPI = () => import(/* webpackChunkName: 'settings' */ "@Components/layouts/app/settings/api/index.vue");
const AppSettingsAPIEdit = () => import(/* webpackChunkName: 'settings' */ "@Components/layouts/app/settings/api/edit.vue");
const AppSettingsAPINew = () => import(/* webpackChunkName: 'settings' */ "@Components/layouts/app/settings/api/new.vue");
//const AppSettingsUsage = () => import(/* webpackChunkName: 'settings' */ "@Components/layouts/app/settings/usage/index.vue");
//const AppSettingsInvoices = () => import(/* webpackChunkName: 'settings' */ "@Views/settings/invoices/Index.vue");
//const AppSettingsSubscription = () => import(/* webpackChunkName: 'settings' */ "@Components/layouts/app/settings/subscription/index.vue");
//const AppSettingsSubscriptionSuccess = () => import(/* webpackChunkName: 'settings' */ "@Components/layouts/app/settings/subscription/success.vue");
//const AppSettingsSubscriptionCancel = () => import(/* webpackChunkName: 'settings' */ "@Views/pricing/ConfirmCancellation.vue");
//const AppSettingsSubscriptionUpdate = () => import(/* webpackChunkName: 'settings' */ "@Views/pricing/ConfirmUpdate.vue");
//const AppSettingsPaymentMethod = () => import(/* webpackChunkName: 'settings' */ "@Components/layouts/app/settings/paymentMethod/index.vue");

const AppTeamMenu = () => import(/* webpackChunkName: 'teams' */ "@Components/layouts/app/settings/SettingsTeamMenu.vue");
const AppTeamProfile = () => import(/* webpackChunkName: 'teams' */ "@Components/layouts/app/settings/teams/profile/index.vue");
const AppTeamMembership = () => import(/* webpackChunkName: 'teams' */ "@Components/layouts/app/settings/teams/team-membership.vue");
const AppTeamSso = () => import(/* webpackChunkName: 'teams' */ "@Components/layouts/app/settings/teams/team-sso.vue");

export default function TeamRoutes(): RouteConfig {
    return {
        path: "/app/organization/:org/team/:team",
        components: {
            default: AppSettingsPage,
        },
        name: "teams.team",
        redirect: { name: "teams.team.profile" },
        children: [
            {
                path: "profile",
                name: "teams.team.profile",
                components: {
                    menu: AppTeamMenu,
                    main: AppTeamProfile,
                },
                props: {
                    main: {
                        billableType: "team",
                    },
                },
                meta: {
                    middleware: [isUserLoggedIn, team],
                },
            },
            {
                path: "membership",
                name: "teams.team.membership",
                components: {
                    menu: AppTeamMenu,
                    main: AppTeamMembership,
                },
                props: {
                    main: {
                        billableType: "team",
                    },
                },
                meta: {
                    middleware: [isUserLoggedIn, team],
                },
            },
            {
                path: "sso",
                name: "teams.team.sso",
                components: {
                    menu: AppTeamMenu,
                    main: AppTeamSso,
                },
                props: {
                    main: {
                        billableType: "team",
                    },
                },
                meta: {
                    middleware: [isUserLoggedIn, team],
                },
            },
            {
                path: "api",
                name: "teams.team.api",
                components: {
                    menu: AppTeamMenu,
                    main: AppSettingsAPI,
                },
                props: {
                    main: {
                        billableType: "team",
                    },
                },
                meta: {
                    middleware: [isUserLoggedIn, team],
                },
            },
            {
                path: "api/edit/:tokenId",
                name: "teams.team.api.edit",
                components: {
                    menu: AppTeamMenu,
                    main: AppSettingsAPI,
                    right: AppSettingsAPIEdit,
                },
                props: {
                    main: {
                        billableType: "team",
                    },
                    right: {
                        billableType: "team",
                    },
                },
                meta: {
                    middleware: [isUserLoggedIn, team],
                },
            },
            {
                path: "api/new",
                name: "teams.team.api.new",
                components: {
                    menu: AppTeamMenu,
                    main: AppSettingsAPI,
                    right: AppSettingsAPINew,
                },
                props: {
                    main: {
                        billableType: "team",
                    },
                    right: {
                        billableType: "team",
                    },
                },
                meta: {
                    middleware: [isUserLoggedIn, team],
                },
            },
            {
                path: "usage",
                name: "teams.team.usage",
                components: {
                    menu: AppTeamMenu,
                    //main: AppSettingsUsage,
                },
                props: {
                    main: {
                        billableType: "team",
                    },
                },
                meta: {
                    middleware: [isUserLoggedIn, team],
                },
            },
            {
                path: "subscription",
                name: "teams.team.subscription",
                components: {
                    menu: AppTeamMenu,
                    //main: AppSettingsSubscription,
                },
                props: {
                    main: {
                        billableType: "team",
                    },
                },
                meta: {
                    middleware: [isUserLoggedIn, team],
                },
            },
            {
                path: "subscription/success",
                name: "teams.team.subscription.success",
                components: {
                    menu: AppSettingsMenu,
                    //main: AppSettingsSubscriptionSuccess,
                },
                props: {
                    main: {
                        billableType: "team",
                    },
                },
                meta: {
                    middleware: [isUserLoggedIn, team],
                },
            },
            {
                path: "subscription/cancel",
                name: "teams.team.subscription.cancel",
                components: {
                    menu: AppTeamMenu,
                    //main: AppSettingsSubscription,
                    //right: AppSettingsSubscriptionCancel,
                },
                props: {
                    main: {
                        billableType: "team",
                    },
                    right: {
                        billableType: "team",
                    },
                },
                meta: {
                    type: "billing",
                    middleware: [isUserLoggedIn, team],
                },
            },
            {
                path: "subscription/update/:subscription/:interval",
                name: "teams.team.subscription.update",
                components: {
                    menu: AppTeamMenu,
                    //main: AppSettingsSubscription,
                    //right: AppSettingsSubscriptionUpdate,
                },
                props: {
                    main: {
                        billableType: "team",
                    },
                    right: (route: Route) => ({
                        ...route.params,
                        billableType: "team",
                    }),
                },
                meta: {
                    type: "billing",
                    middleware: [isUserLoggedIn, team],
                },
            },
            {
                path: "payment-method",
                name: "teams.team.paymentMethod",
                components: {
                    menu: AppTeamMenu,
                    // main: AppSettingsPaymentMethod,
                },
                props: {
                    main: {
                        billableType: "team",
                    },
                },
                meta: {
                    type: "billing",
                    middleware: [isUserLoggedIn, team],
                },
            },
            {
                path: "invoices",
                name: "teams.team.invoices",
                components: {
                    menu: AppTeamMenu,
                    // main: AppSettingsInvoices,
                },
                props: {
                    main: {
                        billableType: "team",
                    },
                },
                meta: {
                    type: "billing",
                    middleware: [isUserLoggedIn, team],
                },
            },
        ].map((r) => ({ ...r, meta: { ...r.meta, navbarEnabled: false } })),
    };
}
